import { render, staticRenderFns } from "./kunststof.vue?vue&type=template&id=0685ec4d"
import script from "./kunststof.vue?vue&type=script&lang=js"
export * from "./kunststof.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports